import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import AgencySettingsFactory from "../../Entity/Factories/AgencySettingsFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { AgencySettingsInterface } from "../../Entity/Entities/Settings/Agency/AgencySettingsInterface";
import Translator from "../../Translation/Translator";

export default function* agencySettingsUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_CLEAR
    });

    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_REQUEST
    });

    const res = yield call(Http.put, `agency-settings`, {...action.payload?.preferences});
    const settings: AgencySettingsInterface = AgencySettingsFactory.create(res.data);

    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_SUCCESS,
      payload: {
        settings: settings
      }
    });

    if (!action.payload?.hideSnackbar) {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-agency-settings-updated-successfully"),
          type: "success"
        }
      });
    }

    yield put({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, settings);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchAgencySettingsUpdate() {
  yield takeEvery(Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_START, agencySettingsUpdate);
}
